import { QueryHookOptions } from '@apollo/client';
import { useApiLazyQuery, useApiQuery } from '@common/hooks';
import { getCurrenciesList, getEntityAuditTrailById } from '@common/services';
import {
  GetCurrenciesListResponse,
  GetEntityAuditTrailByIdResponse,
  GetEntityAuditTrailByIdVariables
} from '@common/types';

const useGetAuditTrailById = () =>
  useApiLazyQuery<
    GetEntityAuditTrailByIdResponse,
    GetEntityAuditTrailByIdVariables
  >(
    getEntityAuditTrailById,
    'getEntityAuditTrailById',
    {
      fetchPolicy: 'cache-and-network'
    },
    {
      withLoader: false
    }
  );

export { useGetAuditTrailById };
